import HorseIcon from './HorseIcon';

export default HorseIcon;
